import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useStateValue } from '../../ContextApi/StateProvider';

function SideMenu() {
  const history = useNavigate();
  const location = useLocation();
  const [{ user }, dispatch] = useStateValue();

  const getNameInitials = (name) => {
    if (!name) return '';
    let initials = name.match(/\b\w/g) || [];
    initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
    return initials;
  };
  const [showSideMenu, setSideMenu] = useState(false);

  return (
    <div>
      <div
        className="fixed block sm:hidden z-60 p-2 bg-white w-full h-10 border"
        onClick={() => setSideMenu((prev) => !prev)}
      >
        <img src="assets/img/sideMenu.png" className="w-6 h-6" />
        {/* <img
          src="assets/img/Close.svg"
          className="absolute top-3 right-3 h-3 cursor-pointer"
          alt=""
          onClick={() => setSideMenu((prev) => !prev)}
        /> */}
      </div>
      <div
        className={`fixed sideMenu ${showSideMenu ? 'block' : 'hidden'} md:block lg:flex flex-col h-full z-50`}
        style={{ width: showSideMenu ? '50%' : '14%' }}
      >
        <div className="flex mb-4" style={{ borderBottom: '1px solid #EFEFEF' }}>
          <img src="assets/img/Logo_App.svg" alt="" className="max-w-full my-4 ml-2 imgSize" />
        </div>

        <div className="w-full mt-4 mb-20 md:mb-0">
          <div
            className={`${
              location.pathname === '/dashboard' && 'text-activeIcon'
            } block md:flex items-center h-1/7 ml-4 mb-1 cursor-pointer`}
            onClick={() => {
              setSideMenu(false);
              history('/dashboard'); // fixed navigation
            }}
          >
            {location.pathname === '/dashboard' ? (
              <div className="bg-btnBg flex w-full h-10 m-auto items-center relative">
                <img src="assets/img/Dashboard_White.svg" alt="" className="h-4 mx-2" />
                <p className="text-white text-sm block">Dashboard</p>
                <img src="assets/img/leftArrow.svg" className="absolute right-4" style={{ height: '10px' }} alt="" />
              </div>
            ) : (
              <div className="flex w-full h-10 m-auto items-center">
                <img src="assets/img/DashbordIcon.svg" alt="" className="h-4 mx-2" />
                <p className="text-textBoldBlack text-sm block">Dashboard</p>
              </div>
            )}
          </div>

          <div
            className={`${
              location.pathname === '/organization' && 'text-activeIcon'
            } block md:flex items-center h-1/7 ml-4 mb-1 cursor-pointer`}
            onClick={() => {
              setSideMenu(false);
              history('/organization'); // fixed navigation
            }}
          >
            {location.pathname === '/organization' ? (
              <div className="bg-btnBg flex w-full h-10 m-auto items-center relative">
                <img src="assets/img/Org_White.svg" alt="" className="h-4 mx-2" />
                <p className="text-white text-sm block">Organization</p>
                <img src="assets/img/leftArrow.svg" className="absolute right-4" style={{ height: '10px' }} alt="" />
              </div>
            ) : (
              <div className="flex w-full h-10 m-auto items-center">
                <img src="assets/img/Org_Green.svg" alt="" className="h-4 mx-2" />
                <p className="text-textBoldBlack text-sm block">Organization</p>
              </div>
            )}
          </div>

          <div
            className={`${
              location.pathname === '/users' && 'text-activeIcon'
            } block md:flex items-center h-1/7 ml-4 mb-1 cursor-pointer`}
            onClick={() => {
              setSideMenu(false);
              history('/users'); // fixed navigation
            }}
          >
            {location.pathname === '/users' ? (
              <div className="bg-btnBg flex w-full h-10 m-auto items-center relative">
                <img src="assets/img/User_White.svg" alt="" className="h-4 mx-2" />
                <p className="text-white text-sm block">Users</p>
                <img src="assets/img/leftArrow.svg" className="absolute right-4" style={{ height: '10px' }} alt="" />
              </div>
            ) : (
              <div className="flex w-full h-10 m-auto items-center">
                <img src="assets/img/UserIcon.svg" alt="" className="h-4 mx-2" />
                <p className="text-textBoldBlack text-sm block">Users</p>
              </div>
            )}
          </div>

          <div
            className={`${
              location.pathname === '/inventory' && 'text-activeIcon'
            } block md:flex h-1/7 items-center ml-4 mb-1 cursor-pointer`}
            onClick={() => {
              setSideMenu(false);
              history('/inventory'); // fixed navigation
            }}
            // style={{ paddingLeft: '0px' }}
          >
            {location.pathname === '/inventory' ? (
              <div className="bg-btnBg flex w-full h-10 m-auto items-center relative">
                <img src="assets/img/Devices_White.svg" alt="" className="h-4 mx-2" />
                <p className="text-white text-sm block">Devices</p>
                <img src="assets/img/leftArrow.svg" className="absolute right-4" style={{ height: '10px' }} alt="" />
              </div>
            ) : (
              <div className="flex w-full h-10 m-auto items-center">
                <img src="assets/img/DevicesIcon.svg" alt="" className="h-4 mx-2" />
                <p className="text-textBoldBlack text-sm block">Devices</p>
              </div>
            )}
          </div>

          <div
            className={`${
              location.pathname === '/events' && 'text-activeIcon'
            } block md:flex h-1/7 items-center ml-4 mb-1 cursor-pointer`}
            onClick={() => {
              setSideMenu(false);
              history('/events'); // fixed navigation
            }}
            // style={{ paddingLeft: '0px' }}
          >
            {location.pathname === '/events' ? (
              <div className="bg-btnBg flex w-full h-10 m-auto items-center relative">
                <img src="assets/img/Devices_White.svg" alt="" className="h-4 mx-2" />
                <p className="text-white text-sm block">Events</p>
                <img src="assets/img/leftArrow.svg" className="absolute right-4" style={{ height: '10px' }} alt="" />
              </div>
            ) : (
              <div className="flex w-full h-10 m-auto items-center">
                <img src="assets/img/DevicesIcon.svg" alt="" className="h-4 mx-2" />
                <p className="text-textBoldBlack text-sm block">Events</p>
              </div>
            )}
          </div>

          <div
            className={`${
              location.pathname === '/firmware' && 'text-activeIcon'
            } block md:flex h-1/7 items-center ml-4 mb-1 cursor-pointer`}
            onClick={() => {
              setSideMenu(false);
              history('/firmware'); // fixed navigation
            }}
            // style={{ paddingLeft: '0px' }}
          >
            {location.pathname === '/firmware' ? (
              <div className="bg-btnBg flex w-full h-10 m-auto items-center relative">
                <img src="assets/img/Firmware_White.svg" alt="" className="h-4 mx-2" />
                <p className="text-white text-sm block">Firmware</p>
                <img src="assets/img/leftArrow.svg" className="absolute right-4" style={{ height: '10px' }} alt="" />
              </div>
            ) : (
              <div className="flex w-full h-10 m-auto items-center">
                <img src="assets/img/Firmware_Grey.svg" alt="" className="h-4 mx-2" />
                <p className="text-textBoldBlack text-sm block">Firmware</p>
              </div>
            )}
          </div>
        </div>

        <div className="logout rounded-md">
          <div
            className={`mr-2 h-6 md:h-12 w-6 md:w-12 flex justify-center items-center rounded-full ${
              !user?.avatar && 'bg-primary'
            } userInfo cursor-pointer`}
            onClick={() => history('/account')}
          >
            {user?.avatar ? (
              <img src={`${user?.avatar}?${global.Date.now()}`} className="h-full w-full rounded-full" />
            ) : (
              <span className="text-base">{getNameInitials(user?.userName)}</span>
            )}
          </div>
          <div className="flex flex-col items-center w-full">
            <span className="text-sm block cursor-pointer" onClick={() => history('/account')}>
              {user?.userName}
            </span>
            <button
              type="submit"
              className="logoutBtn font-bold px-6 py-2"
              onClick={() => {
                sessionStorage.clear();
                history('/', { replace: true }); // fixed navigation
                dispatch({
                  type: 'USER_DATA',
                  user: null,
                });
              }}
            >
              Logout
            </button>
          </div>
        </div>
        {/* <div className="relative bottom-0 text-center text-xs">
        <img src="assets/img/icon1.svg" className="w-28 mx-auto mb-3" alt="" />
        <span className="mx-auto text-textBoldBlack">© 2021. All Rights Reserved</span>
      </div> */}
      </div>
    </div>
  );
}

export default SideMenu;
